@if (event && attendee && attendee.attendeeNumber) {
  <div class="rsvp-qr-code-dialog" mat-dialog-content>
    <div class="dialog-header">
      <div class="dialog-title-custom">
        {{ "APP.QR_CODE" | translate }} | {{ event.name }}
      </div>
      <div class="close-button-custom">
        <i class="far fa-times icon-regular" (click)="close()"></i>
      </div>
    </div>
    <div class="dialog-body">
      <div class="dialog-cont">
        <div class="qrcode-cont">
          <qrcode
            class="qrcode"
            [qrdata]="attendee.attendeeNumber"
            [allowEmptyString]="true"
            [elementType]="'img'"
            [errorCorrectionLevel]="'M'"
            [margin]="0"
            [scale]="1"
            [width]="168"
          ></qrcode>
          <div class="attendee-number">{{ attendee.attendeeNumber }}</div>
        </div>
        @if (isDesktop) {
          <div class="code-info-cont">
            <div class="holder-cont">
              <div class="holder-title">
                {{ "APP.EVENT_RSVP.HOLDER" | translate }}
              </div>
              <div class="holder-data">
                <app-user-avatar
                  [user]="attendee.user"
                  [size]="32"
                  [placeholderFontSize]="14"
                  [fallbackInitials]="attendee.getFallbackInitials()"
                  [backgroundColor]="'var(--bg-tertiary)'"
                ></app-user-avatar>
                <div class="holder-name">
                  {{ attendee.getName() || attendee.getEmail() }}
                </div>
              </div>
            </div>
            <div class="actions-cont">
              <div class="pass-actions">
                <button class="btn btn-primary" (click)="download()">
                  {{ "APP.DOWNLOAD" | translate }}
                </button>
                <i
                  class="fa-regular fa-share-nodes icon-regular btn-icon"
                  (click)="share()"
                >
                </i>
              </div>
              <div class="add-to-wallet-actions">
                <div class="google-wallet" (click)="addToWallet()">
                  <img src="assets/add_to_google_wallet.svg" />
                </div>
                <div class="apple-wallet" (click)="addToWallet()">
                  <img src="assets/add-to-apple-wallet.svg" />
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </div>

    @if (!isDesktop) {
      <div class="mobile-actions">
        <swiper-container
          appSwiper
          #swiperElement
          [config]="swiperActionsConfig"
          #swiperRef
          class="actions-swiper"
        >
          @for (action of GenericAction.getAllRsvpActions(); track $index) {
            @if (shouldShowRsvpAction(action)) {
              <swiper-slide>
                <app-ticket-action
                  [label]="GenericAction.getDisplayName(action)"
                  [icon]="GenericAction.getIcon(action)"
                  [inProgress]="actionInProgress === action"
                  (click)="executeAction(action)"
                />
              </swiper-slide>
            }
          }
        </swiper-container>

        <div class="holder-cont">
          <div class="holder-title">
            {{ "APP.EVENT_RSVP.HOLDER" | translate }}
          </div>
          <div class="holder-data">
            <app-user-avatar
              [user]="attendee.user"
              [size]="32"
              [placeholderFontSize]="14"
              [fallbackInitials]="attendee.getFallbackInitials()"
              [backgroundColor]="'var(--bg-tertiary)'"
            ></app-user-avatar>
            <div class="holder-name">
              {{ attendee.getName() || attendee.getEmail() }}
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
